import { Component, OnInit, Input } from '@angular/core';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { AgeGenderAdaptationSteps, AgeGenderAdaptationStepsValues } from 'src/app/models/AgeGenderAdaptionSteps.model';
import { LuggageCategory } from 'src/app/models/LuggageCategory.model';
import { AgeGender } from 'src/app/models/AgeGender.model';
import { CloneService } from 'src/app/services/clone.service';

@Component({
  selector: 'app-age-gender-adaptation-steps',
  templateUrl: './age-gender-adaptation-steps.component.html',
  styleUrls: ['./age-gender-adaptation-steps.component.scss']
})
export class AgeGenderAdaptationStepsComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('ageGenderAdaptationSteps', this._formBuilder.array([]));
    this.form.setControl('ageGenderAdaptationSteps', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('ageGenderAdaptationSteps');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as AgeGenderAdaptationStepsValues[];
    this.gridData_1=this.ConvertData(1);
    this.gridData_2=this.ConvertData(2);
  }
  asFormGroup(o: AgeGenderAdaptationSteps): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: AgeGenderAdaptationSteps;
  @Input('colHeaders') colHeaders: LuggageCategory[];
  @Input('rowHeaders') rowHeaders: AgeGender[];
  @Input('isEditable') isEditable: boolean;
  @Input('timeType') timeType: boolean;
  gridData_1: GridData=new GridData();
  gridData_2: GridData=new GridData();
  form: FormGroup;
  lascCtrl;

  ConvertData(timeTypeId:number): GridData {
    for (let i = 0; i < this.data.values.length; i++) {
      const element = this.data.values[i];
      if(element.timeTypeId===timeTypeId)
      {
        element.ageGenderId+=1;
      }
    }

    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id + 1,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.colHeaders.length; i++) {
      const headerEntry = this.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.data.values.filter(f=>f.timeTypeId===timeTypeId);
    grid.colProp = 'luggageCategoryId';
    grid.rowProp = 'ageGenderId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalizeAgeGenderAndLuggageTypeIds(temp: AgeGenderAdaptationStepsValues[]) {
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      element.ageGenderId-=1;
      element.value=element.value;
    }
    this.data.values=temp;
  }
  save()
  {
    
    let clonedGridData = this.cloneService.deepClone(this.gridData_1.matrix) as AgeGenderAdaptationStepsValues[];
    let clonedGridData2 = this.cloneService.deepClone(this.gridData_2.matrix) as AgeGenderAdaptationStepsValues[];
    var clonedGridDataConcated = clonedGridData.concat(clonedGridData2);
    this.normalizeAgeGenderAndLuggageTypeIds(clonedGridDataConcated);
    
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
